// Copyright (c) 2025 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import { UseMutationResult, useMutation } from '@tanstack/react-query';
import {
  CredentialOffer,
  CredentialOffer_Reject_Result,
} from '@daml.js/utility-credential-app-v0/lib/Utility/Credential/App/V0/Model/Offer';
import { UserService } from '@daml.js/utility-credential-app-v0/lib/Utility/Credential/App/V0/Service/User';
import { ContractId } from '@daml/types';
import { useLedgerApiClient } from '../../../../contexts/LedgerApiContext';
import { useParties } from '../../../../contexts/PartiesContext';

const useRejectCredentialOffer: () => UseMutationResult<
  CredentialOffer_Reject_Result,
  string,
  {
    userServiceCid: ContractId<UserService>;
    credentialOfferCid: ContractId<CredentialOffer>;
    reason: string;
  }
> = () => {
  const ledgerApi = useLedgerApiClient();
  const { party } = useParties();

  return useMutation({
    mutationKey: ['rejectFreeCredential', ledgerApi, party],
    mutationFn: async ({ userServiceCid, credentialOfferCid, reason }) => {
      return ledgerApi.rejectFreeCredential(userServiceCid, credentialOfferCid, reason, [party]);
    },
  });
};

export default useRejectCredentialOffer;
